import { Component, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { EsiCacheService } from '@app/services/esi-cache.service';

@Component({
  selector: 'app-load-esi-button',
  template: `
    <button
      type="button"
      class="btn btn-outline-info"
      ngbTooltip="Load an ESI from a firmware package into the browser cache so it can be used without writing it to the drive."
      placement="auto"
      container="body"
      (click)="fileInput.click()"
    >
      LOAD ESI
    </button>
    <input #fileInput type="file" accept=".zip" class="d-none" (change)="onFileSelected(fileInput)" />
  `,
  imports: [NgbTooltip],
})
export class LoadEsiButtonComponent {
  private esiCacheService = inject(EsiCacheService);
  private toastr = inject(ToastrService);

  private readonly title = 'Load ESI';

  onFileSelected(input: HTMLInputElement) {
    const file = input.files?.[0];
    input.value = '';

    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.esiCacheService
        .cacheEsiFromFirmwarePackage(file.name, reader.result as ArrayBuffer)
        .then((version) => this.toastr.success(`ESI for firmware ${version} cached in the browser.`, this.title))
        .catch((err: Error) =>
          this.toastr.error(err.message, this.title, {
            disableTimeOut: true,
          }),
        );
    };
    reader.onerror = () => this.toastr.error(`Failed to read "${file.name}".`, this.title, { disableTimeOut: true });
    reader.readAsArrayBuffer(file);
  }
}
